import { monotonicMULSID, mulsid } from "@mpact/mulsid";
import { Fragment, render } from "preact";
import { useState } from "preact/hooks";

function Demo() {
	const [id, setID] = useState(mulsid());
	const [monotonicIDs, setMonotonicIDs] = useState<Array<string>>([
		monotonicMULSID(),
		monotonicMULSID(),
		monotonicMULSID(),
	]);
	const [copyText, setCopyText] = useState("Copy");

	const copy = async (value: string) => {
		await navigator.clipboard.writeText(value);
		setCopyText("Copied ✅");
		setTimeout(() => setCopyText("Copy"), 2000);
	};

	return (
		<>
			<div className="demo">
				<code>{id}</code>
				<button id="generate-btn" type="button" onClick={() => setID(mulsid())}>
					Generate
				</button>
				<button id="copy-btn" type="button" onClick={() => copy(id)}>
					{copyText}
				</button>
			</div>
			<div>Monotonically Increasing (optional)</div>
			<div className="demo">
				<code>
					{monotonicIDs.map((v) => {
						return (
							<Fragment key={v}>
								<span>{v}</span>
								<br />
							</Fragment>
						);
					})}
				</code>
				<button
					id="generate-btn"
					type="button"
					onClick={() =>
						setMonotonicIDs([
							monotonicMULSID(),
							monotonicMULSID(),
							monotonicMULSID(),
						])
					}
				>
					Generate
				</button>
			</div>
		</>
	);
}

// biome-ignore lint/style/noNonNullAssertion: it exists
render(<Demo />, document.getElementById("demo-root")!);
